import { useCallback, useState } from 'react';

import { Download } from 'lucide-react';
import { LoadingSpinner, DefaultTooltip } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid';
import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function DownloadFormatter({ info }) {
  const { events: { handleDownload } } = useGrid()

  const [downloading, setDownloading] = useState(false)

  const { row } = getInfo(info)
  const { id } = row
  const targetId = keyOf(info, 'download')

  const handleClick = useCallback(async () => {
    setDownloading(true)
    await handleDownload(id)
    setDownloading(false)
  }, [handleDownload, id])

  return <>
    <DefaultTooltip content='Download' side='left'>
      <span id={targetId} className="action" onClick={handleClick}>
        {downloading ? <LoadingSpinner width={16} height={16} /> : <Download size={16} />}
      </span>
    </DefaultTooltip>
  </>
}
